import React from "react";
import { useMatches } from "react-router";
export default function Breadcrumbs() {
    var matches = useMatches();
    var crumbs = matches
        // @ts-ignore
        .filter(function (match) { var _a; return Boolean((_a = match.handle) === null || _a === void 0 ? void 0 : _a.crumb); })
        // @ts-ignore
        .map(function (match) { return match.handle.crumb(match.data); });
    // Normal way:
    // return (
    //     <Breadcrumb>
    //         {crumbs.map((crumb, index) => (
    //             <BreadcrumbItem key={index}>{crumb}</BreadcrumbItem>
    //         ))}
    //     </Breadcrumb>
    // );
    // Work around, since we have the routing not set up as they would normally, so this prevents a list in a list
    // We now have the whole breadcrumb in the route component
    // Normally you would add the route component as a child, and it will create the breadcrumb automatically with the parent breadcrumb added as well
    return (React.createElement(React.Fragment, null, crumbs.map(function (crumb, index) { return (React.createElement(React.Fragment, { key: index }, crumb)); })));
}
